var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-link',{attrs:{"href":"#close","aria-label":_vm.$root.translate('Close'),"aria-hidden":"true"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }